
import React from "react";
import { Control } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { WorkoutType } from "@/models/WorkoutType";
import SubscriptionFields from "./SubscriptionFields";
import { useTranslation } from "react-i18next";

interface SubscriptionsStepProps {
  control: Control<any>;
  workoutTypes: WorkoutType[];
  onBack?: () => void;
  onCancel: () => void;
  isLoading: boolean;
  isEditMode: boolean;
}

const SubscriptionsStep: React.FC<SubscriptionsStepProps> = ({ 
  control, 
  workoutTypes, 
  onBack, 
  onCancel, 
  isLoading, 
  isEditMode 
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4 md:space-y-6">
      {workoutTypes.length > 0 && (
        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-semibold">{t('clients.sessionSubscriptions')}</h3>
            <p className="text-sm text-muted-foreground mt-1">
              {t('clients.subscriptionsDescription')}
            </p>
          </div>
          
          <SubscriptionFields control={control} workoutTypes={workoutTypes} />
        </div>
      )}
      
      <div className="flex flex-col md:flex-row justify-between gap-3 md:gap-2 pt-4 md:pt-2">
        {onBack && (
          <Button 
            type="button" 
            variant="outline" 
            onClick={onBack}
            className="h-11 md:h-10 text-base md:text-sm"
          >
            {t('clients.backDetails')}
          </Button>
        )}
        <div className="flex flex-col md:flex-row gap-3 md:gap-2 md:ml-auto">
          <Button 
            type="button" 
            variant="outline" 
            onClick={onCancel}
            className="h-11 md:h-10 text-base md:text-sm "
          >
            {t('common.cancel')}
          </Button>
          <Button 
            type="submit" 
            disabled={isLoading}
            className="h-11 md:h-10 text-base md:text-sm"
          >
            {isLoading 
              ? (isEditMode ? t('clients.updating') : t('clients.creating')) 
              : (isEditMode ? t('clients.updateSubscriptions') : t('clients.createClient'))
            }
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionsStep;
